module.exports = __webpack_public_path__ + "static/img/cchj2.068f7380.png";